import { COLORS } from './CatTripColors';

export const mainNavLinks = {
  mainCategory: {
    label: 'Hard Beverage Hub',
    to: '/categories/hard-bev-hub'
  },
  subCategory: {
    seltzers: { label: 'Seltzers', to: '/categories/hard-bev-hub/seltzers' },
    'teas-lemonades': { label: 'Teas & Lemonades', to: '/categories/hard-bev-hub/teas-lemonades' },
    'sweet-fabs': { label: 'Sweet FABs: Lower-ABV', to: '/categories/hard-bev-hub/sweet-fabs' },
    'higher-abv-fabs': { label: 'Sweet FABs: Higher-ABV', to: '/categories/hard-bev-hub/higher-abv-fabs' },
    'spirit-based-cocktails': {
      label: 'Spirit-Based Cocktails',
      to: '/categories/hard-bev-hub/spirit-based-cocktails'
    },
    shareables: {
      label: 'Shareables',
      to: '/categories/hard-bev-hub/shareables'
    },
    ciders: { label: 'Ciders', to: '/categories/hard-bev-hub/ciders' }
  }
};

export const subNavLinks = [
  { href: '#definition', text: 'Definition' },
  { href: '#sizing', text: 'Sizing' },
  { href: '#consumer-perceptions', text: 'Consumer Perceptions' },
  { href: '#wrap-up', text: 'Wrap Up' }
];

export const navColorSet = {
  seltzers: {
    anchorBarColor: COLORS.SELTZER_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'teas-lemonades': {
    anchorBarColor: COLORS.TEA_LEMONADE_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'sweet-fabs': {
    anchorBarColor: COLORS.SWEET_FAB_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'higher-abv-fabs': {
    anchorBarColor: COLORS.HIGH_ABV_FAB_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  'spirit-based-cocktails': {
    anchorBarColor: COLORS.SPIRIT_COCKTAILS_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  shareables: {
    anchorBarColor: COLORS.SHAREABLES_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  },
  ciders: {
    anchorBarColor: COLORS.CIDERS_PURPLE,
    anchorBarColorSecondary: COLORS.DARK_OVERLAY,
    textColor: COLORS.TEXT_WHITE
  }
};
